import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Box, Paper, Grid } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const ActionItem = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: theme.transitions.create('all'),
  '&:hover': {
    '& .icon-wrapper': {
      backgroundColor: theme.palette.primary.lighter,
      transform: 'translateY(-4px)',
    }
  }
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: 64,
  height: 64,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#F9FAFB',
  marginBottom: theme.spacing(1.5),
  transition: 'all 0.3s ease',
  border: '1px solid #F1F5F9',
  color: theme.palette.primary.main,
}));

// ----------------------------------------------------------------------

YangaQuickActions.propTypes = {
  actions: PropTypes.array,
};

export default function YangaQuickActions({ actions }) {
  return (
    <Paper sx={{ p: 3, borderRadius: '24px', border: '1px solid #F1F5F9', boxShadow: 'none' }}>
      <Typography variant="h6" sx={{ mb: 3, fontWeight: 800 }}>Quick Actions</Typography>
      
      <Grid container spacing={2}>
        {actions.map((action, index) => (
          <Grid item xs={4} sm={2} key={index}>
            <ActionItem onClick={() => window.location.href = action.link}>
              <IconWrapper className="icon-wrapper">
                {typeof action.icon === 'string' ? (
                  <Iconify icon={action.icon} width={28} height={28} />
                ) : (
                  action.icon
                )}
              </IconWrapper>
              <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', textAlign: 'center' }}>
                {action.title}
              </Typography>
            </ActionItem>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
